import _classCallCheck from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { WithStore } from "pure-react-carousel";
import { jsx as ___EmotionJSX } from "@emotion/react";

var CarouselWatcher = /*#__PURE__*/function (_React$Component) {
  _inherits(CarouselWatcher, _React$Component);

  var _super = _createSuper(CarouselWatcher);

  function CarouselWatcher() {
    _classCallCheck(this, CarouselWatcher);

    return _super.apply(this, arguments);
  }

  _createClass(CarouselWatcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.carouselStore !== prevProps.carouselStore) {
        var state = this.props.carouselStore.getStoreState();
        var maxAllowedSlide = state.totalSlides - state.visibleSlides;

        if (state.currentSlide > maxAllowedSlide) {
          this.props.carouselStore.setStoreState({
            currentSlide: maxAllowedSlide
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return ___EmotionJSX(React.Fragment, null);
    }
  }]);

  return CarouselWatcher;
}(React.Component);

export var CarouselWatcherDecorated = WithStore(CarouselWatcher);